import { action, orchestrator } from 'satcheljs';
import saveOrDiscardOptions from '../utils/saveOrDiscardOptions';

export const discardOptions = action('discardOptions');

orchestrator(discardOptions, () => {
    saveOrDiscardOptions(false);
});
